import {FC} from 'react';
import {Box, Button, Flex, Stack} from '@chakra-ui/react';
import {useT} from '@kcast-fe/core';
import {APP_VARS, usePushNotifications} from 'core';
import {Switch} from 'ui-kit';

const NotificationsSettingFC: FC = () => {
  const {isSupported, isSubscribed, isBusy, toggle, sendTest} = usePushNotifications();
  const {t} = useT();

  if (!isSupported) {
    return null;
  }

  return (
    <Stack gap={'8px'}>
      <Flex align={'center'} justify={'space-between'} gap={'16px'} p={'0 4px'}>
        <Box>{t('labels.pushNotifications')}</Box>
        <Switch size={'lg'} checked={isSubscribed} disabled={isBusy} onChange={toggle} />
      </Flex>
      <Flex p={'0 4px'} justifyContent={'space-between'}>
        <Box color={'{colors.textSecondary}'} fontSize={'sm'}>
          {t('labels.pushNotificationsHint')}
        </Box>

        {isSubscribed && APP_VARS.IS_DEV_ENV && (
          <Button
            p={0}
            size={'sm'}
            h={'initial'}
            variant={'plain'}
            disabled={isBusy}
            onClick={sendTest}
            alignSelf={'flex-start'}
            color={'{colors.textLink}'}
          >
            Send test push
          </Button>
        )}
      </Flex>
    </Stack>
  );
};

export const NotificationsSetting = NotificationsSettingFC;
